var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6LoveMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477 477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 477,
    height: 477,
    rx: 112.5,
    ry: 112.5,
    fill: "#18a75b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.19,293.66c-10.08-2.51-20.55-3.81-31.21-3.81-34.23,0-66.41,13.33-90.62,37.53-16.91,16.91-28.51,37.72-33.96,60.4,5.29.56,10.66.86,16.09.86,63.45,0,117.71-39.36,139.69-94.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.99,267.86c13.04,0,25.7,1.67,37.76,4.79,2.55-10.97,3.9-22.4,3.9-34.15,0-69.53-47.26-128.01-111.4-145.09-15.89,65.88-75.2,114.83-145.96,114.83-13.4,0-26.39-1.77-38.75-5.06-2.73,11.33-4.19,23.16-4.19,35.33,0,69.88,47.74,128.61,112.39,145.36,15.46-66.47,75.07-116.01,146.25-116.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.91,148.7c16.66-16.66,28.16-37.09,33.72-59.37-5.62-.64-11.33-.98-17.12-.98-63.02,0-116.96,38.83-139.23,93.87,10.34,2.65,21.07,4.02,32.02,4.02,34.23,0,66.41-13.33,90.62-37.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6LoveMark);
export default __webpack_public_path__ + "static/media/6love-mark.9ddda63ed6e5fb4b7864834c3b4b8142.svg";
export { ForwardRef as ReactComponent };